import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const DateRangePicker = ({ bubbleUpDateOnChange, size = 'medium' }) => {
    const defaultRange = [dayjs().add(-7, 'day'), dayjs()];

    const handleStartDateChange = (date) => {
        if (bubbleUpDateOnChange) {
            const endDate = dayjs(); // You might want to get this from state
            bubbleUpDateOnChange([date, endDate], [date?.format('DD-MM-YYYY'), endDate?.format('DD-MM-YYYY')]);
        }
    };

    const handleEndDateChange = (date) => {
        if (bubbleUpDateOnChange) {
            const startDate = dayjs().add(-7, 'day'); // You might want to get this from state
            bubbleUpDateOnChange([startDate, date], [startDate?.format('DD-MM-YYYY'), date?.format('DD-MM-YYYY')]);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <DatePicker
                    label="Start Date"
                    value={defaultRange[0]}
                    onChange={handleStartDateChange}
                    format="DD-MM-YYYY"
                    slotProps={{
                        textField: {
                            size: size === 'small' ? 'small' : 'medium',
                            sx: { minWidth: 150 }
                        }
                    }}
                />
                <Box sx={{ color: 'text.secondary' }}>to</Box>
                <DatePicker
                    label="End Date"
                    value={defaultRange[1]}
                    onChange={handleEndDateChange}
                    format="DD-MM-YYYY"
                    slotProps={{
                        textField: {
                            size: size === 'small' ? 'small' : 'medium',
                            sx: { minWidth: 150 }
                        }
                    }}
                />
            </Box>
        </LocalizationProvider>
    );
};

export default DateRangePicker;